export enum DropdownTypeEnum {
  CUSTOMER_REGION = 'CustomerRegion',
  CUSTOMER_SITE = 'CustomerSite',
  CASE_TYPE = 'CaseType',
  CLASSIFICATION = 'Classification',
  PRODUCT_FAMILY = 'ProductFamily',
  PRODUCT_GROUP = 'ProductGroup',
  PRODUCT_SUB_GROUP = 'ProductSubGroup',
  EQUIPMENT_STATUS = 'EquipmentStatus',
  STC_ENGAGED = 'StcEngaged',
  CASE_STAGE = 'CaseStage',
  NEXT_ACTION_STATUS = 'NextActionStatus',
  FAMILY_NAME = 'FamilyName',
  FAMILY_VARIANT = 'FamilyVariant',
  TOOL_MANUFACTURER = 'ToolManufacturer',
  TOOL = 'Tool',
  CHAMBER = 'Chamber',
  PROCESS_TYPE = 'ProcessType',
  SUPPLIER_ENGAGED = 'SupplierEngaged',
  DISTRIBUTED_MANUFACTURING_PC = 'DistributedManufacturingPc',
  CUSTOMER_COUNTRY = 'CustomerCountry',
  GLOBAL_CUSTOMER_NAME = 'CustomerGlobalName',
  SMA_FACTORY_NAME = 'SmaFactoryName',
  ESCALATION_CATEGORY = 'EscalationCategory',
  PROBLEM_PRIORITY = 'ProblemPriority',
  PROBLEM_RECORD_STAGE = 'ProblemRecordStage',
  PROBLEM_RECORD_STATUS = 'ProblemRecordStatus',
  PRODUCT_COMPANY = 'ProductCompany',
  PRODUCT_SUITE = 'ProductSuite',
  ROOT_CAUSE_CATEGORY = 'RootCauseCategory',
  ROOT_CAUSE_SYSTEM_COMPONENT = 'RootCauseSystemComponent',
  CUSTOMER_INFORMATION = 'CustomerSitesComplex',
  PROCESS_INFORMATION = 'ProcessInformationComplex',
  PRODUCT_INFORMATION = 'ProductInformationComplex',
  ROOT_CAUSE_SYSTEM_COMPONENT_COMPLEX = 'RootCauseSystemComponentComplex',
  ROOT_CAUSE = 'RootCause',
  REGIONAL_TSM_COMPLEX = 'RegionalTSMComplex',
  STC_COMPLEX = 'STCComplex',
  CUSTOMER_CENTER_APPS_COMPLEX = 'CustomerCenterAPPsComplex', 
  CUSTOMER_CENTER_COMPLEX = 'CustomerCenterComplex',
  PRODUCT_COMPANY_COMPLEX = 'ProductCompanyComplex',
}

export enum DropdownEntryEnum {
  ENTRY_1 = 'entry1',
  ENTRY_2 = 'entry2',
  ENTRY_3 = 'entry3',
  ENTRY_4 = 'entry4',
  ENTRY_5 = 'entry5',
  ENTRY_6 = 'entry6',
} 